<template>
    <div class="message-item__content--recording">
        <div class="recording">
            <span
                class="recording__item"
                v-for="index in 6"
                :key="index"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MessageContentRecording'
    }
</script>

<style lang="scss" scoped>
    .recording {
        @include flex-center;
        background-color: $primary-color;
        width: 78px;
        height: 40px;
        padding: 10px 15px;
        white-space: nowrap;
        @include radius(.5, .25, .5, .5);

        &__item {
            display: inline-block;
            height: 16px;
            width: 4px;
            vertical-align: bottom;
            background-color: #fff;
            animation: wave 1s linear infinite both;
            transform-origin: 50% 100%;

            &:not(:last-child) {
                margin-right: 4px;
            }

            $delay: 0, .4, .8, 0, .4, .8;
            $i: 0;
            @each $item in $delay {
                $i: $i + 1;
                &:nth-child(#{$i}) {
                    animation-delay: #{$item}s;
                }
            }

            @keyframes wave {
                0%, 100% {
                    transform: scaleY((4 / 16))
                }
                25%, 75% {
                    transform: scaleY((10 / 16))
                }
                50% {
                    transform: scaleY((16 / 16))
                }
            }
        }
    }
</style>
